import '../webpack-env';

// Runtime config (window.__APP_CONFIG__ from /config.js) wins when set, so the
// API base URL can be chosen at deploy time. Otherwise fall back to the value
// baked in at build time by webpack DefinePlugin.
const runtimeConfig: AppRuntimeConfig | undefined = globalThis.window?.__APP_CONFIG__;

function resolveConfig(runtimeValue: string | undefined, buildTimeValue: string): string {
  return runtimeValue && runtimeValue.trim().length > 0 ? runtimeValue : buildTimeValue;
}

export const API_BASE_URL: string = resolveConfig(runtimeConfig?.API_BASE_URL, __ENV_API_BASE_URL__);

/** LK Domain Registry search origin for Register / Enquire deep links. */
export const REGISTRY_PUBLIC_ORIGIN: string = resolveConfig(
  runtimeConfig?.REGISTRY_PUBLIC_ORIGIN,
  __ENV_REGISTRY_ORIGIN__,
);

/**
 * Page size for reading a saved session (the API's maximum). The backend applies
 * the standard and premium batch limits; the UI shows every name it returns.
 */
export const SESSION_PAGE_LIMIT = 100 as const;

export const PROMPT_MIN_LENGTH = 1 as const;
export const PROMPT_MAX_LENGTH = 300 as const;
